import React from 'react';
import styles from './Research.module.css';

const ResearchNews = () => {
  const newsItems = [
    {
      id: 1,
      title: "Borrowing money from a friend? Here's why you should be cautious of it",
      category: "HDFC Bank Report",
      date: "August 06, 2025",
      image: "/Research/image1.png",
      link: "https://www.hdfc.bank.in/blogs/personal-loan/what-happens-when-you-borrow-money-from-friends"
    },
    {
      id: 2,
      title: "Rules to Follow when lending to Frineds , associates",
      category: "Rules & Regulations",
      date: "Jan 10, 2026",
      image: "/Research/image2.png",
      link: "https://economictimes.indiatimes.com/wealth/borrow/rules-to-follow-when-lending-to-friends-associates/articleshow/54496034.cms?from=mdr"
    },
    {
      id: 3,
      title: "Tips for borrowing money from family and friends",
      category: "Wells Fargo Report",
      date: "March , 2025",
      image: "/Research/image3.png",
      link: "https://smallbusinessresources.wf.com/what-to-consider-when-borrowing-from-family-and-friends/"
    },
    {
      id: 4,
      title: "Borrowing Money from friends vs Family vs Personal Loan ",
      category: "Piramal Finance Report",
      date: "August 08, 2023",
      image: "/Research/image4.png",
      link: "https://www.piramalfinance.com/vidya/why-borrowing-money-from-other-individuals-is-not-a-good-thing-compare-to-personal-loan"
    },
    {
      id: 5,
      title: "Cash-driven informal credit market reaches $500 billion in India",
      category: "Business Standard Research",
      date: "September 14, 2025",
      image: "/Research/image5.png",
      link: "https://www.business-standard.com/article/economy-policy/cash-driven-informal-credit-market-reaches-500-billion-in-india-121070800619_1.html"
    },
    {
      id: 6,
      title: "Reliance on informal finance persists despite multiple financial inclusion measures",
      category: "The Economics Time Report",
      date: "June 10, 2025",
      image: "/Research/image6.png",
      link: "https://economictimes.indiatimes.com/industry/banking/finance/reliance-on-informal-finance-persists-despite-multiple-financial-inclusion-measures-report/articleshow/122005718.cms?from=mdr"
    },
    {
      id: 7,
      title: "Struggles of low-income households at the cusp of informal-formal housing finance",
      category: "India Housing Report",
      date: "October 26, 2021",
      image: "/Research/image7.png",
      link: "https://indiahousingreport.in/outputs/opinion/struggles-of-low-income-households-at-the-cusp-of-informal-formal-housing-finance/"
    },
    {
      id: 8,
      title: "India’s poor have bank accounts but are increasingly going to money lenders for loans",
      category: "The Hindu Report",
      date: "July 17, 2025",
      image: "/Research/image8.png",
      link: "https://www.thehindu.com/business/Economy/indias-poor-have-bank-accounts-but-are-increasingly-going-to-money-lenders-for-loans-data-shows/article69803357.ece"
    },
    {
      id: 9,
      title: "Why over 50% of urban poor in India still rely on informal credit systems",
      category: "Mint Money Report",
      date: "December 18, 2024",
      image: "/Research/image9.png",
      link: "https://www.livemint.com/money/personal-finance/why-over-50-of-urban-poor-in-india-still-rely-on-informal-credit-systems-find-out-loans-11734505443020.html"
    },
    {
      id: 10,
      title: "Informal finance still thriving in rural India",
      category: "RBI Report",
      date: "july 29, 2024",
      image: "/Research/image10.png",
      link: "https://research.rupayya.com/reports/mobile-lending"
    },
    {
      id: 11,
      title: "Informal finance and rural finance policy in India",
      category: "Historical and contemporary perspectives",
      date: "August 06, 2008",
      image: "/Research/image11.png",
      link: "https://www.tandfonline.com/doi/abs/10.1080/09584930802271315"
    },
    {
      id: 12,
      title: "Drowning in debt: How easy loans are turning into an EMI nightmare for Indians",
      category: "India Today Report",
      date: "Jan 10, 2026",
      image: "/Research/image12.png",
      link: "https://www.indiatoday.in/business/personal-finance/story/india-silent-debt-crisis-easy-loans-bnpl-apps-emi-burden-expert-panel-report-2849529-2026-01-10"
    },
    {
      id: 13,
      title: "In villages, credit is still all about moneylenders",
      category: "Economics Time Report",
      date: "May 15, 2013",
      image: "/Research/image13.png",
      link: "https://economictimes.indiatimes.com/industry/banking/finance/banking/in-villages-credit-is-still-all-about-moneylenders/articleshow/20057478.cms?from=mdr"
    },
    {
      id: 14,
      title: "Many low-income Indians still take informal loans despite better bank access",
      category: "ZBusiness Report",
      date: "July 16, 2025",
      image: "/Research/image14.png",
      link: "https://www.zeebiz.com/economy-infra/news-many-low-income-indians-still-take-informal-loans-despite-better-bank-access-piramal-report-373677"
    },
    {
      id: 15,
      title: "Interest Rates in Informal Credit Markets and Their Impact on National Accounts",
      category: "Economic and Political Weekly Report",
      date: "June 24, 2023",
      image: "/Research/image15.png",
      link: "https://www.epw.in/journal/2023/25-26/commentary/interest-rates-informal-credit-markets-and-their.html"
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Header */}
        <header className={styles.header}>
          <h1 className={styles.title}>Research & Insights</h1>
          <p className={styles.subtitle}>Latest research, reports, and analysis on F2F lending</p>
        </header>

        {/* News Grid */}
        <div className={styles.newsGrid}>
          {newsItems.map((item) => (
            <div key={item.id} className={styles.newsCard}>
              <div className={styles.imageContainer}>
                <img 
                  src={item.image} 
                  alt={item.title}
                  className={styles.newsImage}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/Research/default.png";
                  }}
                />
                <div className={styles.categoryBadge}>{item.category}</div>
              </div>
              
              <div className={styles.newsContent}>
                <div className={styles.date}>{item.date}</div>
                <h3 className={styles.newsTitle}>{item.title}</h3>
                
                <div className={styles.cardFooter}>
                  <a 
                    href={item.link} 
                    className={styles.readLink}
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Read Research →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <footer className={styles.footer}>
          <p className={styles.footerText}>
            Subscribe to our research newsletter for regular updates
          </p>
          <div className={styles.subscribe}>
            <input 
              type="email" 
              placeholder="Enter your email"
              className={styles.emailInput}
            />
            <button className={styles.subscribeButton}>Subscribe</button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ResearchNews;